export default {
  STATUS: {
    APPROVE: 1,
    DENY: 2,
    MEDICAL_REVIEW: 3,
    INSURANCE_REVIEW: 4,
    REMOVE_FROM_LIST: 5
  },
  ID: {
    1: "APPROVE",
    2: "DENY",
    3: "MEDICAL_REVIEW",
    4: "INSURANCE_REVIEW",
    5: "REMOVE_FROM_LIST"
  },
  DISPLAY_NAMES: {
    1: "Approved",
    2: "Denied",
    3: "Medical Review",
    4: "Insurance Review",
    5: "Remove From List"
  },
  DESCRIPTIONS: {
    1: "Approved to Play",
    2: "Denied from Play",
    3: "Placed Under Medical Review",
    4: "Placed Under Insurance Review",
    5: "Removed From Chronic Condition Table"
  }
};
